var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 50,
    height: 50,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10l1.5-4.5h15L21 10h-2l-1.5-4H6.5L5 10H3zm13.5 4c.83 0 1.5.67 1.5 1.5S17.33 17 16.5 17s-1.5-.67-1.5-1.5S15.67 14 16.5 14zm-9 0c.83 0 1.5.67 1.5 1.5S8.33 17 7.5 17s-1.5-.67-1.5-1.5S6.67 14 7.5 14zM4 18v-1h16v1h1v2h-1v1h-2v-1H6v1H4v-1H3v-2h1zm2-3v-4h12v4H6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.78f9b8f1aa25d72157e981207799ced3.svg";
export { ForwardRef as ReactComponent };